if(BSS_BCP_V2.r4q?.logics?.length && window.location.pathname === '/pages/historial-presupuestos-corporativos') {
    const interval = setInterval(()=> {
      const buttonTarget = document
          .querySelector('bcp-r4q-history-page')
          ?.shadowRoot
          ?.querySelector('bcp-r4q-quote-detail')
          ?.shadowRoot
          ?.querySelector('button.buyer-counter-button');
    if(buttonTarget){
      clearInterval(interval)
      buttonTarget.style.display = 'none';
    } 
  }, 100) 
  
}